
import { Typography } from 'antd';
const { Title, Paragraph } = Typography;

function Agreement() {
    return (
        <Typography style={{ width: "1000px", margin: "auto"}}>
            <Title style={{ textAlign: "center",margin:"50px"}}>免责条款</Title>
            <Paragraph style={{ textIndent: "30px" }}>
                本协议系由【上海麦咭文化传媒有限公司】与所有付费使用魔席网的主体（包括但不限于个人、团队等）（以下简称“用户”）对魔席网付费会员服务的使用及相关服务所订立的有效合约。为使用魔席网付费会员服务（简称为：本服务），请您仔细阅读、理解并遵守《魔席网付费会员服务协议》（简称为：本协议）。本协议由您与魔席网共同缔结，具有合同效力。协议中存在相关免除或限制责任的相应条款（以下称“免责条款”）、对用户权利进行限制的条款（以下称“限制条款”）、约定争议解决方式和司法管辖的条款。前述，该等免责、限制及争议解决方式和管辖条款可能以黑体加粗、颜色标记或其他合理方式提示您注意，并请您重点阅读，您对该等条款的确认将可能导致您在特定情况下的被动、不便、损失，请您在确认同意本协议之前或在使用魔席网会员服务协议之前再次阅读前述条款。
            </Paragraph>

            <Title level={3}>
                一、定义和说明
            </Title>

            <Paragraph>
                1.1【魔席网】是【上海麦咭文化传媒有限公司】为网友提供的文化和旅游行业工具类网站是供网友在线使用行业资讯、行业热点大数据的监测和分析工具。旨在为用户提供内容的生成、传播和学习等平台服务。
            </Paragraph>

            <Paragraph>
                1.2【付费会员产品】付费会员产品是指魔席网平台使用供用户交流学习的付费类的工具和信息等资源。
            </Paragraph>

            <Paragraph>
                1.3【本服务】魔席网付费会员服务，指按照本协议的约定，魔席网付费会员服务在收到您支付的足额的费用后，向您提供对应收费工具和信息在线使用服务。
            </Paragraph>

            <Title level={4}>
                【条款修改】
            </Title>

            <Paragraph>
                魔席网有权随时对服务条款进行修改（修改包含变更、增加、减少相应的条款内容），一旦服务条款发生修改，魔席网将在相关页面进行更新展示。如果您不同意本条款的修改，可以停止对本服务的使用。您继续使用魔席网提供的服务，则视为您已经接受本条款的全部修改。
            </Paragraph>

            <Title level={4}>
                1.4【本协议】
            </Title>

            <Paragraph>
                1.4.1 本协议视为《使用魔席网前必读》（若链接地址变更的，则以变更后的链接地址所对应的内容为准；其他链接地址变更的情形，均适用前述约定。）、《魔席网服务协议》、《特权介绍》、《魔席网会员自动续费服务协议》的补充协议，是其不可分割的组成部分，与其构成统一整体。本协议与上述内容存在冲突的，以本协议为准。
            </Paragraph>

            <Paragraph>
                1.4.2 本协议内容同时包括魔席网可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分。同样对双方生效。
            </Paragraph>

            <Title level={3}>
                二、帐号管理及使用规则
            </Title>

            <Title level={4}>
                2.1 【帐号管理】
            </Title>

            <Paragraph>
                2.1.1 您应正确使用及妥善保管、维护您的魔席网帐号及密码，如发生任何泄漏、遗失、被盗等行为，而该等行为并非魔席网法定过错导致，所有损失将由您自行承担；
            </Paragraph>

            <Paragraph>
                2.1.2 您在此授予魔席网保护您帐号安全的相关权利，魔席网可定期或不定期采用不同的方式对您帐号的使用安全进行检查、验证，包括但不限于主动联系您进行身份验证、短消息验证、邮箱认证及密码修改等。如您无法完成验证或无正当理由拒绝验证的，魔席网可合理怀疑您的帐号出现异常或被盗，并中止向该帐号提供服务或采取进一步措施。
            </Paragraph>

            <Paragraph>
                2.1.3 本服务仅供您成功购买付费会员服务时选择的魔席网账号使用。如您需更换魔席网账号来接受相应服务时，如该服务为付费作品时，则您需另行支付相应的费用。
            </Paragraph>

            <Title level={4}>
                2.2 【使用规则】
            </Title>

            <Title level={5}>
                2.2.1【合法获取及使用】
            </Title>

            <Paragraph>
                (1) 魔席网付费会员服务 ，均仅限于您在魔席网平台内使用，任何以破解、转译、转录等非法手段将魔席网服务与魔席网平台分离的行为，均不属于本条款中约定的魔席网付费会员服务。魔席网保留追究侵权人的法律责任及索赔的权利。
            </Paragraph>

            <Paragraph>
                (2) 任何以盗窃、利用系统漏洞、通过任何非魔席网官方或授权途径获得的魔席网付费会员服务（包括但不限于购买、租用、借用、分享、受让等方式获得）、恶意利用或破坏魔席网付费会员获得的服务，均不获相关保护，魔席网有权取消及/或不予提供付费会员服务，所有产生的损失及责任由行为人自行承担。
            </Paragraph>

            <Paragraph>
                (3) 使用魔席网付费会员服务及/或参加相关活动时，亦应通过魔席网官方公布/授权的方式进行，用户通过其他任何渠道、任何途径、任何方式非法获取的魔席网付费会员服务（包括且不限于帐号、付费服务权益、服务邀请码等）或参加活动获取福利（包括但不限于获得实体/虚拟礼品、付费服务权益、服务邀请码等），均不获保护，且一经发现魔席网有权立即就相关服务做出删除、取消、清零等处理，或采取其他如中止或终止对您提供服务等帐号管理措施，所有产生的损失及责任由行为人自行承担。
            </Paragraph>

            <Paragraph>
                (4) 您参加付费服务活动时，应按照活动规则、以合法及不损害活动举办方的方式进行，利用系统漏洞、规则设置缺陷、系统设置错误、滥用会员身份等参加活动并获取相关福利的，均不获保护，且魔席网有权采取相关措施进行处理，所有产生的损失及责任由行为人自行承担。
            </Paragraph>

            <Title level={5}>
                2.2.2 【专有及非商业目的使用】
            </Title>

            <Paragraph>
                (1) 魔席网付费作品服务，是在您遵守本条款及相关法律法规的前提下，魔席网给予您一项个人的、不可转让及非排他性的许可。您仅可为非商业目的使用，并仅可用作私人使用。
            </Paragraph>

            <Paragraph>
                (2) 您知悉并同意，您购买的付费服务仅限于您自行使用，您无权对购买的收费数字作品及相关增值服务服务进行出售、转让、许可、传播或以其他方式使除您自己以外的第三方（包括但不限于自然人、法人或其他组织）使用。否则，因此产生任何法律后果及责任均由您自行承担，魔席网有权视情况采取如下措施而无需承担任何责任：
            </Paragraph>

            <Paragraph>
                (2.1) 取消您继续使用该付费服务的权利；
            </Paragraph>

            <Paragraph>
                (2.2) 限制、冻结、终止您的帐号；
            </Paragraph>

            <Paragraph>
                (2.3) 要求您退还通过出售、转让、许可等其他方式取得的收益；
            </Paragraph>

            <Paragraph>
                (2.4) 其他魔席网付费会员认为可以采取的救济措施。
            </Paragraph>

            <Title level={5}>
                2.2.3 【帐号独立】
            </Title>

            <Paragraph>
                (1）同一主体拥有多个魔席网帐号并进行魔席网会员登录的，每一个魔席网帐号将被识别为一个独立的帐号
            </Paragraph>

            <Paragraph>
                (2) 每个帐号之间的购买记录、文档数据无法进行转移、迁徙、转让、赠与、售卖、租借、分享，无论该等帐号是否由同一使用人拥有，请您在登录及/或购买/参加活动时注意区分，避免造成损失。魔席网会视情况采取中止或终止对您提供服务，由此造成的损失由您自行承担。
            </Paragraph>

            <Title level={5}>
                2.2.4 【登录限制】
            </Title>

            <Paragraph>
                您理解并同意，在开通本服务后，同一个帐号最多可以在六个设备（“设备”指包括但不限于计算机及移动电话、平板电脑等手持移动终端设备，下同）上使用，且同一时间内同一帐号最多在两个设备上使用。超过上述范围使用的，魔席网将会根据情况中止或终止对您的服务。造成的损失将由您自行承担，且魔席网保留采取进一步措施的权利。
            </Paragraph>

            <Title level={5}>
                2.2.5 【帐号找回】
            </Title>

            <Paragraph>
                您登录魔席网时使用的魔席网账号信息遗失、忘记密码，导致无法登录魔席网的，您如需找回的，需按照魔席网官方公布的帐号找回流程的要求提供相应的信息和证明，并确保提供的信息和证明文件的合法真实有效，若提供的材料不真实或不符合要求，无法通过魔席网的安全验证，可能会导致帐号找回失败，相应的风险和损失将由您自行承担。您理解魔席网对您的请求采取行动及处理均需要合理时间，除魔席网存在法定过错外，魔席网对您的损失不承担任何责任。
            </Paragraph>

            <Paragraph>
                2.3 您理解并同意，工具所有者或数字作品发布者通过魔席网平台发布的收费产品将采用整体购买的方式，即用户只需购买一次，就可以获得该产品对应年限的权益（对于视频课程类，用户只需购买一次，就可以学习该课程所有已发布或即将发布的课时）。
            </Paragraph>

            <Paragraph>
                已购买的收费数字作品，您可以自己重复学习，无需再次付费，但报告/音频／视频类数字作品仅可在线观看、不支持下载。
            </Paragraph>

            <Title level={3}>
                三、付费会员服务内容
            </Title>

            <Title level={4}>
                3.1 【付费服务权益】
            </Title>


            <Paragraph>
                3.1.1 在您开通付费会员服务后（即魔席网付费会员在收到您支付的足额的费用后），将会向您提供对应收费产品的在线使用／观看学习服务。
            </Paragraph>

            <Paragraph>
                根据您的购买记录及您参加的相关活动，将会享有对应服务体验，具体以相关服务页面公布、实际提供的内容为准。
            </Paragraph>

            <Title level={4}>
                3.2 【设备及系统差异】
            </Title>

            <Paragraph>
                您通过魔席网指定渠道开通本服务后，可能会由于您使用的软件版本、设备、操作系统等不同以及其他第三方原因等导致您实际可使用的具体服务有差别，由此可能给您带来的不便，您表示理解，您不予追究或者豁免魔席网的相关责任。
            </Paragraph>

            <Title level={4}>
                3.3 【关于收费】
            </Title>

            <Paragraph>
                本服务是魔席网提供的收费服务，您须在按照本服务的收费标准支付相应费用后，方可使用本服务。根据实际状况，不同产品的付费价格可能会不同，具体以购买页面公示信息为准。
            </Paragraph>

            <Paragraph>
                同时我们也鼓励您定期查看本协议内容，以更好地保障您的权益。您在此理解并同意因所购买产品不同，魔席网付费用户将享受不同的增值服务。
            </Paragraph>

            <Title level={4}>
                3.4 【支付】
            </Title>

            <Paragraph>
                3.4.1 您应该通过魔席网指定的包括但不限于支付宝支付、微信支付等方式等现有方式或今后魔席网指定方式，依约支付。支付完成后，不可进行转让或退订。
            </Paragraph>

            <Paragraph>
                3.4.2 您理解并同意：魔席网付费会员提供付费服务实行先付款后使用的方式，您及时、足额、合法的支付所需的款项是您获得该等服务的前提。您有权选择使用魔席网付费会员认可的支付方式，您理解并确认支付服务由魔席网付费会员之外具备合法资质的第三方提供，该等支付服务的使用条件及规范由您与支付服务提供方确定，与魔席网付费会员无关。
            </Paragraph>

            <Paragraph>
                3.4.3 您不得通过以下任何方式为自己或他人开通本服务：
            </Paragraph>

            <Paragraph>
                (1) 以营利、经营等非个人使用的目的为自己或他人开通本服务；
            </Paragraph>

            <Paragraph>
                (2）通过任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件等任何程序、软件方式为自己或他人开通本服务；
            </Paragraph>

            <Paragraph>
                (3）通过任何不正当手段或以违反诚实信用原则的方式为自己或他人开通本服务；
            </Paragraph>

            <Paragraph>
                (4) 通过非魔席网指定的方式为自己或他人开通本服务；
            </Paragraph>

            <Paragraph>
                (5) 通过侵犯魔席网或他人合法权益的方式为自己或他人开通本服务；
            </Paragraph>

            <Paragraph>
                (6) 通过其他违反相关法律、行政法规、国家政策等的方式为自己或他人开通本服务；
            </Paragraph>

            <Paragraph>
                3.5 魔席网平台上出售的任何服务，一经售出，将一律概不予退款。
            </Paragraph>

            <Title level={3}>
                四、违约责任
            </Title>

            <Paragraph>
                4.1.1 您在使用本服务的过程中，不得进行以下违约行为：
            </Paragraph>

            <Paragraph>
                4.1.2 违反法律、法规、规章、条例以及任何具有法律效力之规范规定的；
            </Paragraph>

            <Paragraph>
                4.1.3 破坏、影响魔席网对任何第三方提供本服务；
            </Paragraph>

            <Paragraph>
                4.1.4 进行危害计算机网络安全的行为；
            </Paragraph>

            <Paragraph>
                4.1.5 对魔席网及关联第三方（包括授权方和合作方）提供的本条款服务、活动造成不良影响，侵犯及/或关联第三方魔席网及/或其他用户的正当利益；
            </Paragraph>

            <Paragraph>
                4.1.6 被有权机构认定侵犯任何第三方的合法权益的；
            </Paragraph>

            <Paragraph>
                4.1.7 利用本服务获取非法利益的，包括但不限于通过转售、转让、转授权等行为不正当牟利；
            </Paragraph>

            <Paragraph>
                4.1.8 其他侵犯魔席网合法利益的行为；
            </Paragraph>

            <Title level={4}>
                4.2 【违约行为处理】
            </Title>

            <Paragraph>
                您确认并同意，在发现违约行为后，魔席网有权采取以下一项或多项措施处理：
            </Paragraph>

            <Paragraph>
                (1) 采取技术手段予以删除、屏蔽或断开相关的信息；
            </Paragraph>

            <Paragraph>
                (2) 采取包括但不限于中止或终止部分或全部本服务；
            </Paragraph>

            <Paragraph>
                (3) 采取扣除违约行为发生时间内的会员权益；
            </Paragraph>

            <Paragraph>
                (4) 采取限制用户下载、播放、复制、存储等权益；
            </Paragraph>

            <Paragraph>
                (5) 魔席网无需向您退还任何费用，未使用的服务费用作为违约金归魔席网所有，您的相关会员权益的损失由您自行承担，造成魔席网损失的（包括但不限于律师费、诉讼费等），您也应予以赔偿；
            </Paragraph>

            <Title level={4}>
                4.3 【赔偿责任】
            </Title>
            <Paragraph>
                如用户的违约行为或违法行为使【上海麦咭文化传媒有限公司】及其关联公司遭受损失，包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失，被告应当赔偿魔席网及其关联公司的上述全部损失，您的违约行为导致任何第三方损害的，您应当独立承担责任。
            </Paragraph>
            <Title level={3}>
                五、服务的变更、中止及终止
            </Title>

            <Paragraph>
                5.1 经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为的，或者魔席网付费会员根据自身的判断、认为您的行为涉嫌违反本协议内容的，或涉嫌违反法律法规的规定的，则魔席网付费会员有权中止、中断或终止向您提供付费服务，并无需向您退还任何费用以及不承担任何责任。
            </Paragraph>

            <Paragraph>
                5.2 除法律规定的责任外，魔席网对本服务的中止或终止对用户和任何第三人不承担任何责任。
            </Paragraph>

            <Paragraph>
                5.3 魔席网依据本协议的约定变更服务内容、服务方式以及本协议内容的，如果您不同意魔席网的变更，有权选择取消并停止使用本服务；如果您继续使用魔席网提供的上述服务，则视为您已经接受魔席网的上述调整。
            </Paragraph>

            <Paragraph>
                5.4 您同意，由于互联网服务的特殊性，魔席网有权基于合法理由，修改、变更、中断或终止部分或全部服务，或变更、删除、转移用户存储、发布在魔席网的内容，统称“变更行为”。魔席网保留采取前述变更行为而不需通知您的权利，且您同意，依本服务条款任何规定提供之本服务，无需进行事先通知即可变更、中断或终止。并且您同意，由于变更行为而造成的任何损失，魔席网无需对您或对任何第三人承担任何责任。
            </Paragraph>

            <Title level={3}>
                六、免责声明
            </Title>

            <Paragraph>
                6.1 您知悉并同意，数字产品提供者在魔席网平台上上传、发布或传输的内容，为其个人行为，魔席网不对该等信息和内容的准确性、真实性、可用性、安全性、完整性和正当性承担责任，您在此同意豁免追加魔席网的相关责任。
            </Paragraph>

            <Paragraph>
                6.2 您在进行相关信息及内容的使用、分享、下载等行为（“使用行为”）时，应进行独立判断并合法使用，因您的使用行为造成任何自身损害及对第三方的损害，魔席网不承担任何责任。
            </Paragraph>

            <Paragraph>
                6.3 因电信和网通部门的通讯线路故障、网络或电脑故障、系统不稳定、不可抗力（如服务器当机）等非魔席网原因造成您帐号、帐号内财产等丢失、减少的，您无权要求魔席网承担补偿等责任。
            </Paragraph>

            <Paragraph>
                6.4 您在使用魔席网所提供的服务时，如遭受任何人身或财务的损失、损害或伤害，除法律有明确规定外，魔席网不承担任何责任。由于您将个人密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露，魔席网不承担任何责任。
            </Paragraph>

            <Title level={3}>
                七、通知
            </Title>

            <Paragraph>
                本协议项下魔席网对于用户所有的通知均可通过网页公告、手机短信或常规的信件传送等方式进行，该等通知于发送之日视为已送达用户。为便于您收取相关通知，您应确保预留的联系方式为正确及有效，并在变更后及时登录魔席网修改，如因您未提供正确的联系信息或未及时告知新的联系方式，导致无法及时收取通知，将由您自行承担由此产生的损失及法律后果。魔席网可通过上述方式之一或其中若干向您送达各类通知，而此类通知的内容或将对您产生重大有利或不利影响，请您务必确保联系方式为有效并请及时关注。
            </Paragraph>

            <Title level={3}>
                八、法律的适用和管辖
            </Title>

            <Paragraph>
                8.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。
            </Paragraph>

            <Paragraph>
                8.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均可向魔席网公司所在地上海人民法院提起诉讼。
            </Paragraph>

            <Paragraph>
                8.3 魔席网公司未行使或执行本服务协议任何权利或规定，不构成对前述权利或权利之放弃。
            </Paragraph>

            <Paragraph>
                8.4 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
            </Paragraph>

            <Paragraph>
                8.5 在法律法规允许的范围内，魔席网有权对本协议进行解释。
            </Paragraph>
            <div style={{height:"100px"}}></div>
        </Typography>
    )
}

export default Agreement;